import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../../atoms/icon";
import { GA } from "../../../../integrations";
import { get } from "lodash";

import styles from "./styles.m.css";

export class SocialShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.hanldeAction = this.hanldeAction.bind(this);
  }

  hanldeAction(args) {
    const id = get(this.props.story, ["story-content-id"], []);
    const { handleClickView } = this.props;
    GA.customEvent("Share Click", args, id);
    if (args === "comments") handleClickView();
  }

  render() {
    const { fbUrl, twitterUrl, handleShare, className, story, fullUrl } = this.props;
    const subheadline = ` ${story.subheadline} `;
    const whatsApp = `https://api.whatsapp.com/send?text=${encodeURIComponent(subheadline)}`.concat(
      encodeURIComponent(fullUrl)
    );
    let bottomtext =
      " %0a %0a முக்கியச் செய்திகள், சிறப்புப் பேட்டிகள், அலசல் %0a கட்டுரைகளுக்கு Vikatan App-ஐ டவுன்லோடு செய்ய %0a \n https://vikatan.onelink.me/kbqn/VikatanWhatsApp";
    return (
      <div className={`${className} ${styles["social-share"]}`}>
        <ul className={`${styles["social-share__icons"]}`}>
          <li
            className={`${styles["social-share__whatsapp"]} ${
              styles["social-share__icon--whatsapp"]
            } social-share__icon--whatsapp`}
          >
            <a
              aria-label="whatsapp share"
              href={`${whatsApp}${encodeURIComponent("?utm_source=mobile&utm_medium=whatsapp")} ${bottomtext}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__whatsapp-icon"]}`}
              onClick={this.hanldeAction.bind(this, "whatsapp")}
            >
              <Icon type="whatsapp" />
            </a>
          </li>

          <li
            className={`${styles["social-share__icon"]} ${
              styles["social-share__icon--facebook"]
            } social-share__icon--facebook`}
          >
            <a
              aria-label="facebook share"
              href={fbUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__fb-icon"]}`}
              onClick={this.hanldeAction.bind(this, "facebook")}
            >
              <Icon type="facebook" />
            </a>
          </li>
          <li
            className={`${styles["social-share__icon"]} ${
              styles["social-share__icon-twitter"]
            } social-share__icon--twitter`}
          >
            <a
              aria-label="twitter share"
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__twitter--icon"]}`}
              onClick={this.hanldeAction.bind(this, "twitter")}
            >
              <Icon type="twitter" />
            </a>
          </li>

          {handleShare && (
            <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--app-share"]}`}>
              <button
                aria-label="Share this"
                onClick={handleShare}
                className={`${styles["social-share__link"]} ${styles["social-share__share-app-share"]}`}
                role="button"
              >
                <Icon type="mobile-share" />
              </button>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

SocialShareTemplate.propTypes = {
  className: PropTypes.string,
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  handleShare: PropTypes.func,
  handleClickView: PropTypes.func,
  color: PropTypes.string,
  story: PropTypes.shape(),
  fullUrl: PropTypes.string
};
